import { Injectable } from '@angular/core';
import { hideLoader } from '@app/core/interceptors/interceptor-http-params';
import { GraphqlService } from '@app/core/services/graphql.service';
import { saveOperationPointMutation } from '@app/pcs/data/operation-point.mutations';
import {
  fetchOperationPointsQuery,
  fetchOperationPointsWithEditRuleQuery,
  validatePrimaryLocationCodeQuery
} from '@app/pcs/data/operation-point.queries';
import { OperationPoint } from '@app/pcs/models';
import { OperationPointSearchContext } from '@app/pcs/models/operation-point-search-context';
import { UserGridType } from '@app/pcs/models/user-grid-type';
import { map } from 'rxjs/operators';

@Injectable()
export class OperationPointDataService {

  constructor(private graphqlService: GraphqlService) {
  }

  fetchOperationPoints(searchContext: OperationPointSearchContext, showLoader = false) {
    return this.graphqlService.query(fetchOperationPointsQuery, {
      searchContext
    }, showLoader ? null : hideLoader());
  }

  fetchOperationPointsWithEditRules(searchContext: OperationPointSearchContext) {
    return this.graphqlService.query(fetchOperationPointsWithEditRuleQuery, {
      searchContext: searchContext,
      countries: searchContext.countries,
      userGridType: {id: UserGridType.OperationPoints}
    }).pipe(map(response => ({
      operationPoints: response[0],
      operationPointsEditRules: response[1],
      userGridConfiguration: response[2]
    })));
  }

  save(operationPoint: OperationPoint) {
    return this.graphqlService.mutation(saveOperationPointMutation, {
      operationPoint
    });
  }

  validatePrimaryLocationCode(operationPoint: OperationPoint) {
    return this.graphqlService.query(validatePrimaryLocationCodeQuery, {
      operationPoint
    }, hideLoader());
  }
}
